type CalendarShiftOptions = {
  direction?: string | null;
  schedule?: Array<{ date?: string | null }> | null;
  firstDate?: string | null;
  lastDate?: string | null;
  days?: number;
  minDate?: Date;
};

export function resolveCalendarShiftDate(options: CalendarShiftOptions): Date | null {
  const direction = options && options.direction ? String(options.direction) : '';
  const schedule = Array.isArray(options.schedule) ? options.schedule : [];
  const firstDate = options.firstDate || (schedule.length ? schedule[0].date || null : null);
  const lastDate = options.lastDate || (schedule.length ? schedule[schedule.length - 1].date || null : null);
  const days = Number.isFinite(Number(options.days)) ? Number(options.days) : 0;

  const minDate = options.minDate instanceof Date ? new Date(options.minDate.getTime()) : new Date();
  minDate.setHours(0, 0, 0, 0);

  if (direction === 'next') {
    if (!lastDate) {
      return null;
    }
    const base = new Date(`${lastDate}T00:00:00`);
    if (Number.isNaN(base.getTime())) {
      return null;
    }
    base.setDate(base.getDate() + 1);
    return base;
  }

  if (direction === 'prev') {
    if (!firstDate) {
      return null;
    }
    const base = new Date(`${firstDate}T00:00:00`);
    if (Number.isNaN(base.getTime())) {
      return null;
    }
    const candidate = new Date(base);
    candidate.setDate(candidate.getDate() - days);
    if (candidate < minDate) {
      candidate.setTime(minDate.getTime());
    }
    if (candidate.getTime() === base.getTime()) {
      return null;
    }
    return candidate;
  }

  return null;
}
